import {
  type SchemeAddonListQueryResult,
  type SchemeAddonListQuery_Query,
  type SchemeAddonListQuery_table_SchemeAddonConnection_nodes_SchemeAddon,
  useSchemeAddonListQuery,
} from '~/gql/generated/graphql'

// Define a skeleton of data so the table can be shown
// with the loading state if there isn't any data yet
export const defaultData: SchemeAddonListQuery_Query = {
  __typename: 'Query',
  table: {
    __typename: 'SchemeAddonConnection',
    nodes: [],
    pagination: {
      __typename: 'Pagination',
      total: 0,
      current: 0,
      pageSize: 0,
    },
  },
  role_types: [],
}

export type UseSchemeAddons = Pick<
  SchemeAddonListQueryResult,
  'data' | 'loading'
>

// Use this type for listings, and as query might not include all fields that
// the SchemeAddon type has
export type SchemeAddonListItem =
  SchemeAddonListQuery_table_SchemeAddonConnection_nodes_SchemeAddon

export const useSchemeAddons = ({
  schemeId,
  current,
  pageSize,
}): UseSchemeAddons => {
  const variables = {
    scheme_id: schemeId,
    paginate: { page: current, per_page: pageSize },
  }

  const { data, loading } = useSchemeAddonListQuery({
    variables,
    pollInterval: 0,
  })

  return { data, loading }
}
